// Browser specs render <html data-test-env="true"> (layouts add it only in Rails'
// test environment) and wait a tenth of UI delays such as debounces and
// slide-outs. Everywhere else the delays are unchanged.
export const isTestEnv = () => document.documentElement.dataset.testEnv === "true";

export const paced = (ms) => (isTestEnv() ? ms * 0.1 : ms);
